import { defineStore } from 'pinia'

import api from '@/api/kyc.js'

export const useKycStore = defineStore('kyc', {
  state: () => ({
    profile: {},
    kyc: {},
    ktpImage: '',
    ktpData: {}
  }),
  actions: {
    getProfile ({ success, fail }) {
      api.getProfile()
        .then(response => {
          this.profile = response.body.data
          success && success(response)
        })
        .catch(error => fail && fail(error))
    },
    getKycStatus ({ success, fail }) {
      api.getKycStatus()
        .then(response => {
          this.kyc = response.body.data
          success && success(response)
        })
        .catch(error => {
          fail && fail(error)
        })
    },
    getKtpImage ({ success, fail }) {
      api.getKtpImage()
        .then(response => {
          this.ktpImage = response.body.data.nikImage
          success && success(response)
        })
        .catch(error => fail && fail(error))
    },
    insertKyc ({ requestBody, success, fail }) {
      api.insertKyc(requestBody)
        .then(response => success && success(response))
        .catch(error => fail && fail(error))
    },
    validateKtpImage ({ requestBody, success, fail }) {
      api.validateKtpImage(requestBody)
        .then(response => {
          this.ktpData = response.body.data
          success && success(response)
        })
        .catch(error => fail && fail(error))
    }
  }
})
